import { useEffect } from 'react';

function RedirectGoBandung() {

  useEffect(() => {
    const targetUrl = `https://bit.ly/m/FamilyMart-GOBandung`;
    window.location.href = targetUrl;
  }, []);

  return (
    <div></div>
  );
}

export default RedirectGoBandung;
